import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Container"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "container"
    }}>{`Container`}</h1>
    <p>{`Centered, max-width layout component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Container } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Container p={4} bg="muted">
  Centered container
</Container>
`}</code></pre>
    <p>{`The Container component's max-width can be defined in `}<inlineCode parentName="p">{`theme.sizes.container`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Container variants can be defined in the `}<inlineCode parentName="p">{`theme.layout`}</inlineCode>{` object.
The Container component uses `}<inlineCode parentName="p">{`theme.layout.container`}</inlineCode>{` as its default variant style.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      